import { useSelector } from "react-redux";
import { useLocalStorage } from "react-use";
import { getIsOnDemand } from "~/store/selectors/selector.configOptions";
import { getInstanceId } from "~/store/selectors/selector.instance";
import { getLoggedUserId } from "~/store/selectors/selector.users";

export const useACLocalStorage = (keyName, initialValue = undefined, options = undefined) => {
  const isOnDemand = useSelector(getIsOnDemand);
  const loggedUserId = useSelector(getLoggedUserId);
  const instanceId = useSelector(getInstanceId);

  const localStorageKeyName =
    isOnDemand && instanceId
      ? "instance_" + `${instanceId}` + "_user_" + `${loggedUserId}` + "_" + keyName
      : "user_" + `${loggedUserId}` + "_" + keyName;

  return useLocalStorage(localStorageKeyName, initialValue, options);
};
